/** Tailwind badge classes aligned with calendar booking status colors. */
export function getBookingStatusBadgeClass(status: string): string {
  switch (status) {
    case 'completed':
      return 'bg-green-100 text-green-700';
    case 'in_progress':
      return 'bg-yellow-100 text-yellow-700';
    case 'scheduled':
      return 'bg-blue-100 text-blue-700';
    case 'cancelled':
      return 'bg-red-100 text-red-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

/** Hex colors used on calendar events (see bookings.ts getStatusColor). */
export function getBookingStatusColor(status: string): string {
  switch (status) {
    case 'completed':
      return '#22c55e';
    case 'in_progress':
      return '#eab308';
    case 'scheduled':
      return '#3b82f6';
    case 'cancelled':
      return '#ef4444';
    default:
      return '#3b82f6';
  }
}
